import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { JsonFormData } from '../dialog-dynamic/dialog-dynamic.component';

@Component({
  selector: 'telio-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {

  showTable = false;
  formData: JsonFormData;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.http.get('/assets/my-form.json')
    .subscribe((formData: any) => {
      this.formData = formData;
    })
  }

}
